import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Form from 'react-bootstrap/Form';

import { useCreateUserFromCraftable } from './useCreateUserFromCraftable';
import LoadingScreen from '../LoadingScreen';

interface MigrationFormProps {
    onSuccess: () => void;
}

function MigrationForm({ onSuccess }: MigrationFormProps): JSX.Element {
    const { createUserFromCraftable } = useCreateUserFromCraftable();
    // Form Data
    const [ableToSubmit, setAbleToSubmit] = useState<boolean>(true);
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [emailAddress, setEmailAddress] = useState<string>('');
    const [craftablePassword, setCraftablePw] = useState<string>('');
    const [drinkUpPassword, setDrinkUpPassword] = useState<string>('');
    const [isCreatingUser, setCreatingUser] = useState<boolean>(false);
    const [isMigrationSuccessful, setIsMigrationSuccessful] = useState<boolean>(false);
    const [isMigrationFailure, setIsMigrationFailure] = useState<boolean>(false);
    const [failureReason, setFailureReason] = useState<string | null>(null);

    const validateForm = (): boolean => {
        console.log("test")

        if (!!firstName && !!lastName && !!emailAddress && !!craftablePassword && !!drinkUpPassword) {
            
            if(firstName === "") {
                console.log("aa")
                setFailureReason("first name cannot be empty");
                setAbleToSubmit(false);
                return false;
            }

            if(lastName === "") {
                setAbleToSubmit(false);
                setFailureReason("last name cannot be empty");
                return false;
            }

            if(emailAddress === "") {
                setAbleToSubmit(false);
                setFailureReason("email address cannot be empty");
                return false;
            }

            if(craftablePassword === "") {
                alert("craftable password cannot be empty");
                setAbleToSubmit(false);
                setFailureReason("craftable password cannot be empty");
                return false;
            }

            if(drinkUpPassword.length < 8) {
                setAbleToSubmit(false);
                setFailureReason("Rumbustible Password must be 8 characters or longer");
                return false;
            }
            
            setFailureReason(null);
            setAbleToSubmit(true);
            return true;
        } else {
            setAbleToSubmit(false);
            setFailureReason("all fields need to be filled out");
            return false;
        }
    };

    const onFormControlChngWrapper = (changefn: (value: string) => void) => (el: React.ChangeEvent<HTMLInputElement>) => {
        el.preventDefault();

        changefn(el.target.value);
        validateForm();
    }

    const onSubmit = async (el: React.FormEvent<HTMLFormElement>): Promise<void> => {
        el.preventDefault()

        console.log("email:" + emailAddress);

        if(validateForm() === false) {
            return;
        }

        if (!ableToSubmit) return;

        // Submit Form via POST
        const userToCreate = {
            firstName, lastName, emailAddress, craftablePassword, drinkUpPassword
        };
        // set loading
        setCreatingUser(true);

        try {
            const resStatus = await createUserFromCraftable(userToCreate);

            console.log("createUserFromCraftable result: " + resStatus);

            if(resStatus === true) {
                setIsMigrationSuccessful(true);
            } else {
                console.log(resStatus.response?.data);
                if(resStatus.response?.data) {
                    if(resStatus.response.data.failure) {
                        if(resStatus.response.data.failure === "bad_password") {
                            setFailureReason("Your password was incorrect, please try again");
                            setIsMigrationFailure(true);
                            return;
                        }
                    }
                }
                
                setIsMigrationFailure(true);
            }
        } catch(e) {
            setIsMigrationFailure(true);
        } finally {
            setCreatingUser(false);
        }
    };

    if(isCreatingUser) {
        return (<>
            <Stack className='text-center'>
                <LoadingScreen />
                <p>Please be patient, this could take a while</p>
            </Stack>
        </>);
    }

    if(isMigrationSuccessful) {
        return (<>
            <Stack gap={3} className='text-center'>
                <h1>Migration was successful!</h1>
                <p> Login to access your account</p>
                <Button variant="primary" onClick={onSuccess}>Go to Login</Button>
            </Stack>
        </>);
    }

    if(isMigrationFailure && failureReason) {
        return (
            <p>Your email/password was incorrect. Please try again or contact an admin to have it reset.</p>
        );
    }

    if(isMigrationFailure) {
        return (
            <p>Migration failed, please contact an administrator for support.</p>
        );
    }

    return (
        <Form style={{ 'minWidth': '20rem' }} onSubmit={onSubmit}>
            <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email address</Form.Label>
                <Form.Control type="email" placeholder="Enter email" onChange={onFormControlChngWrapper(setEmailAddress)} />
                <Form.Text className="text-muted">
                    This email will represent your login
                </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formFirstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" placeholder="First Name" onChange={onFormControlChngWrapper(setFirstName)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formLastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" placeholder="Last Name" onChange={onFormControlChngWrapper(setLastName)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formCraftablePw">
                <Form.Label>Current Craftable Password</Form.Label>
                <Form.Control type="password" placeholder="Current Password" onChange={onFormControlChngWrapper(setCraftablePw)} />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formDrinkUpPw">
                <Form.Label>New Rumbustible Password</Form.Label>
                <Form.Control type="password" placeholder="New Password" onChange={onFormControlChngWrapper(setDrinkUpPassword)} />
                <Form.Text className="text-muted">
                    Password can be same as before. Whatever you want this to be. Must be at least 8 characters in length.
                </Form.Text>
            </Form.Group>
            {
                !!failureReason
                    ? <><p style={{ 'color': 'red' }}>{failureReason}</p></> : ""
            }
            <div>
                <Button variant="primary" className="ml-auto"
                    type="submit">
                    Migrate Account
                </Button>
            </div>
        </Form >
    );
}

export { MigrationForm };
